var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWithdrawal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 3,
    fill: "#7B410E",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.6923V20L22.1538 22.1538M20 27C23.8662 27 27 23.8662 27 20C27 16.1338 23.8662 13 20 13C16.1338 13 13 16.1338 13 20",
    stroke: "#E67E22",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0342 24.6631L15.79 25.5664H11.2002L11.4492 24.6631H16.0342ZM13.749 30L11.3418 27.1582L11.3369 26.377H12.499C12.7822 26.377 13.015 26.3249 13.1973 26.2207C13.3828 26.1133 13.5212 25.9684 13.6123 25.7861C13.7067 25.6038 13.7539 25.3988 13.7539 25.1709C13.7539 24.9333 13.7116 24.7233 13.627 24.541C13.5423 24.3555 13.4072 24.2106 13.2217 24.1064C13.0361 24.0023 12.7904 23.9502 12.4844 23.9502H11.2051L11.4834 22.8906H12.4844C13.0638 22.8906 13.5456 22.9785 13.9297 23.1543C14.3171 23.3268 14.6068 23.5791 14.7988 23.9111C14.9941 24.2399 15.0918 24.637 15.0918 25.1025C15.0918 25.5094 15.0234 25.8691 14.8867 26.1816C14.7533 26.4909 14.5368 26.7432 14.2373 26.9385C13.9378 27.1338 13.5439 27.264 13.0557 27.3291L15.2383 29.9316V30H13.749ZM16.0391 22.8906L15.79 23.7939H12.0156L12.2646 22.8906H16.0391Z",
    fill: "#E67E22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawal);
export default __webpack_public_path__ + "static/media/withdrawal.41a21b679a749848d8e4ce1bf1270dba.svg";
export { ForwardRef as ReactComponent };